<app-dialog-banner [text]="'Send Email — ' + data.person.fullName + (data.person.email ? ' <' + data.person.email + '>' : ' (no email on file)')" [dialogRef]="dialogRef"></app-dialog-banner>

<div style="padding: 2px 10px 0; min-width: 700px;" data-form-ready="true">
    <app-ctl-holder [control]="subjectField.control"></app-ctl-holder>
    <app-ctl-holder [control]="contentField.control"></app-ctl-holder>
    <div style="display:flex; align-items:flex-end; margin-top:-25px; padding-left:5px; padding-bottom:6px;">
        <div style="flex:1;">
            <div style="display:flex; align-items:center; padding-bottom:2px;">
                <span class="row-label">Attach:</span>
                <app-mail-attachment-chips
                    [availableAttachments]="data.availableAttachments"
                    [(attachments)]="selectedAttachments">
                </app-mail-attachment-chips>
            </div>
            <div style="display:flex; align-items:center;">
                <span class="row-label">Statement:</span>
                <div style="min-width:160px;"><app-ctl-holder [control]="statementField.control" on='grid'></app-ctl-holder></div>
                @if (statementTypeField.visible.form) {
                    <span class="row-label" style="margin-left:8px;">Type:</span>
                    <div style="min-width:220px;"><app-ctl-holder [control]="statementTypeField.control" on='grid'></app-ctl-holder></div>
                }
            </div>
        </div>
        <div style="white-space:nowrap; padding-left:8px;">
            <button mat-button data-field-name="preview" [matTooltip]="previewTooltip" matTooltipPosition="above"
                [disabled]="!subjectField.control.valid || attachmentSizeExceeded || isSending"
                (click)="doPreview()">
                Preview
            </button>
            <button mat-button data-field-name="attach" [matTooltip]="attachTooltip" matTooltipPosition="above"
                [disabled]="!subjectField.control.valid || attachmentSizeExceeded || isSending"
                (click)="confirmAttach()">
                Attach
            </button>
            <button mat-button data-field-name="test" [matTooltip]="testTooltip" matTooltipPosition="above"
                [disabled]="!subjectField.control.valid || attachmentSizeExceeded || isSending"
                (click)="confirmTest()">
                Test
            </button>
            <span [matTooltip]="!hasValidEmail ? sendDisabledReason : sendTooltip" matTooltipPosition="above">
                <button mat-raised-button color="primary" data-save-button
                    [disabled]="!hasValidEmail || !subjectField.control.valid || attachmentSizeExceeded || isSending"
                    (click)="confirmSend()">
                    Send
                </button>
            </span>
        </div>
    </div>
</div>
